import { createContext } from 'react';

/**
 * CR-55 / D103 - the rate a retailer reads an INDICATIVE figure at. From the `me` payload, set once by
 * the session, so no screen fetches a rate. `from` is the currency prices are held in: a conversion is
 * only offered for an amount in that currency, so it can never be applied to a figure that is already
 * something else. Null means "show the base price alone" - the correct answer, not an error.
 *
 * Its own file because `ui/index.tsx` exports components only (fast refresh).
 */
export interface IndicativeRate { from: string; currency: string; rate: string; effectiveFrom: string }

export const IndicativeRateContext = createContext<IndicativeRate | null>(null);
export const IndicativeRateProvider = IndicativeRateContext.Provider;
